import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { useState, type FormEvent } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { post } from '../../lib/api.ts';
import { ControlPicker } from '../../components/ControlPicker.tsx';
import { CYCLE_LABEL } from '../../lib/evidence.ts';
import { Button } from '../../components/ui/Button.tsx';
import { ErrorText } from '../../components/AuthShell.tsx';
import { FormSheet, FormSection, FormField, UnitInput, ftInput } from '../../components/ui/FormTable.tsx';
import { EntityPicker } from '../../components/ui/EntityPicker.tsx';
import { useUserPicker } from '../../lib/pickers.ts';

export function EvidenceItemNewPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const userPicker = useUserPicker();
  const [f, setF] = useState({ title: '', description: '', cycle: 'none', validityDays: '', ownerId: '', controlIds: [] as string[] });
  const create = useMutation({ mutationFn: () => post<{ id: string }>('/evidence/items', { ...f, validityDays: f.validityDays ? Number(f.validityDays) : null, ownerId: f.ownerId || undefined }), onSuccess: (r) => { qc.invalidateQueries({ queryKey: ['evidence-grid'] }); navigate(`/evidence/items/${r.id}`); } });
  return (
    <div className="">
      <PageHeader title="증적 항목 등록" back={{ to: '/evidence', label: '목록' }} />
      <FormSheet description="증적 항목은 통제항목에 매핑되는 「무엇을 증명하는 자료인가」의 단위입니다. 파일은 항목 상세에서 버전으로 올립니다." actions={<><Button variant="secondary" onClick={() => navigate('/evidence')}>취소</Button><Button type="submit" busy={create.isPending}>저장</Button></>} onSubmit={(e: FormEvent) => { e.preventDefault(); create.mutate(); }}>
        <FormSection title="기본정보">
          <FormField label="제목" required><input className={ftInput} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} required /></FormField>
          <FormField label="담당자" hint="비우면 나"><EntityPicker value={f.ownerId} onChange={(v) => setF({ ...f, ownerId: v })} emptyLabel="(나)" {...userPicker} /></FormField>
          <FormField label="설명" span={2}><input className={ftInput + ' ft-w-full'} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} /></FormField>
        </FormSection>
        <FormSection title="주기 · 유효기간">
          <FormField label="주기" hint="회차(월·분기·반기·연)마다 승인 버전이 있어야 충족"><select className={ftInput + ' ft-w-sm'} value={f.cycle} onChange={(e) => setF({ ...f, cycle: e.target.value })}>{Object.entries(CYCLE_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></FormField>
          <FormField label="유효기간" hint="비우면 무기한 · 캡처 시각 + N일"><UnitInput unit="일" type="number" min={1} value={f.validityDays} onChange={(e) => setF({ ...f, validityDays: e.target.value })} /></FormField>
        </FormSection>
        <FormSection title="통제항목 매핑" cols={1}>
          <FormField label="통제항목" hint="검색·프레임워크 탭으로 좁혀 체크. 선택한 항목은 위에 칩으로 표시"><ControlPicker value={f.controlIds} onChange={(controlIds) => setF({ ...f, controlIds })} /></FormField>
        </FormSection>
        <ErrorText error={create.error} />
      </FormSheet>
    </div>
  );
}
